import {
  ITransactionDetailGroup,
  ITransactionDetailItem,
  TransactionType,
} from '@varo/graphql-schema-types';
import RecipientListItem from 'features/v2a/sender/components/RecipientListItem';
import {
  getAvatarInitials,
  getAvatarTheme,
} from 'features/v2a/sender/helpers/Sender.helpers';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { ListItemLineFormat } from 'shared/components/vxl/ListItem/ListItemTextStack';
import theme from 'shared/styles/theme';
import { getUuid } from 'shared/utils/getUuid/getUuid';

import {
  hasCopy,
  isTransactionDetailV2ACustomerItem,
} from './transactionDetails.helpers';

const TransactionItems = ({
  items,
  type,
}: {
  items: Array<ITransactionDetailGroup>;
  type: TransactionType;
}) => {
  const isV2ATransaction = type === TransactionType.V2A;

  return (
    <View>
      {items.map((group: ITransactionDetailGroup, index: number) => {
        const groupKey = `Group-${index}`;
        return isV2ATransaction ? (
          <View key={groupKey}>
            {group.items.map(
              (item: ITransactionDetailItem, indexChild: number) => {
                const showsDivider = indexChild < group.items.length - 1;

                return hasCopy(item) || item.value.length > 0 ? (
                  <View key={item.key + item.value}>
                    {isTransactionDetailV2ACustomerItem(item) ? (
                      <RecipientListItem
                        key={item.key}
                        id={item.id}
                        subTitle={item.title ?? ''}
                        title={item.copy ?? ''}
                        avatarTheme={getAvatarTheme(
                          getAvatarInitials(item.copy),
                        )}
                        lineFormat={ListItemLineFormat.LABEL}
                        showVaroLogo={false}
                      />
                    ) : (
                      <View>
                        <ListItem
                          primaryCopy={hasCopy(item) ? item.copy : item.value}
                          secondaryCopy={
                            item?.value || hasCopy(item) ? item?.title : null
                          }
                          lineFormat={ListItemLineFormat.LABEL}
                          showsChevron={false}
                        />
                        {showsDivider ? (
                          <View style={styles.separatorWrapper}>
                            <HairLineDivider />
                          </View>
                        ) : null}
                      </View>
                    )}
                  </View>
                ) : null;
              },
            )}
            {index < items.length - 2 ? (
              <View style={styles.separatorWrapper}>
                <HairLineDivider />
              </View>
            ) : null}

            {index === items.length - 2 ? (
              <View style={styles.divider} />
            ) : null}
          </View>
        ) : (
          <View key={getUuid()}>
            {group.items.map(
              (item: ITransactionDetailItem, indexChild: number) => {
                return (
                  <View key={item.key + item.value}>
                    <ListItem
                      primaryCopy={hasCopy(item) ? item.copy : item.value}
                      secondaryCopy={item?.value ? item?.title : null}
                      lineFormat={ListItemLineFormat.LABEL}
                      showsChevron={false}
                    />
                    {indexChild < group.items.length - 1 ? (
                      <View style={{ paddingHorizontal: theme.spacing.m }}>
                        <HairLineDivider />
                      </View>
                    ) : null}
                  </View>
                );
              },
            )}
            {index < items.length - 1 ? <View style={styles.divider} /> : null}
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  divider: {
    backgroundColor: theme.color.background.surface,
    height: theme.spacing.s,
  },
  separatorWrapper: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default TransactionItems;
